/*
Chrome is really aggressive about autofilling form fields,
even when you have autocomplete="off" set.
This is because historically, many forms have been built with a default of
autocomplete="off", which would disable it on forms that actually need it.
They view CRM systems as in the minority, and not worth the trade-off
of no longer helping with forms that have bad defaults.

The workaround (for now) is to have autocomplete value that doesn't match anything.

From:
  https://bugs.chromium.org/p/chromium/issues/detail?id=468153#c164
Linked from:
  https://github.com/alphagov/accessible-autocomplete/issues/325
*/

export function stopChromeAutofill(): string {
  return Math.random().toString(36).substring(2);
}
